import { render, staticRenderFns } from "./LogAgendamentoModal.vue?vue&type=template&id=68613910"
import script from "./LogAgendamentoModal.vue?vue&type=script&lang=js"
export * from "./LogAgendamentoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports